import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronWide2OutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m15.498 10.786-.697 1.215-6.802-3.906L1.199 12 .5 10.786 8 6.48z" fill="currentColor" />
            <path d="m15.498 6.81-.697 1.213-6.802-3.906-6.8 3.906L.5 6.81 8 2.502z" fill="currentColor" />
        </g>
    </svg>
));
ChevronWide2OutlinedSize16Glyph.displayName = 'ChevronWide2OutlinedSize16Glyph';
